import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router";
import HSGCard from "../../../Components/HSGCard/HSGCard";
import RootLayout from "../../../Components/shared/RootLayout";
import entgrey from "../../../Containers/DashboardContainer/Component/NewUiimg/grey_icons/entgrey.png";
import eyegrey from "../../../Containers/DashboardContainer/Component/NewUiimg/grey_icons/eyegrey.png";
import growgrey from "../../../Containers/DashboardContainer/Component/NewUiimg/grey_icons/growgrey.png";
import physicqlgrey from "../../../Containers/DashboardContainer/Component/NewUiimg/grey_icons/physical_grey.png";
import toothgrey from "../../../Containers/DashboardContainer/Component/NewUiimg/grey_icons/toothgrey.png";
import CONSTANTS from "../../../Phi/Constants";
import Phi from "../../../Phi/Phi";
import entnormal from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/entnormal.png";
import entyellow from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/entyellow.png";
import eyenormal from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/eyenormal.png";
import eyeyellow from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/eyeyellow.png";
import toothnormal from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/toothnormal.png";
import studentprofile from "../../DashboardContainer/Component/NewUiimg/student-profile.png";
import vac from "../../DashboardContainer/Component/NewUiimg/vac.png";
import HSGPopupContainer from "../../HSGPopup/HSGPopupComponent";
import EpisodeForm from "../../SmartClinicContainer/Component/Episode/EpisodeForm";

import growthnormal from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/growthnormal.png";
import growyellow from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/growyellow.png";
import physicalnormal from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/physicalnormal.png";
import physicalyellow from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/physicalyellow.png";
import toothyellow from "../../DashboardContainer/Component/NewUiimg/My_HealthSetGo/toothyellow.png";
import StudentCard from "./StudentCard";
import { keyMappings } from "../../../utils/helper";
import history from "../../../history";
import { REPORT_TYPES } from "../../../utils/helpers/reportNavigation";
import BackButton from "../../../Components/shared/BackButton";
import RenderYearTab from "../../../Components/shared/RenderYearTab";
import { PALLETTE } from "../../../utils/theme";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
//to make css style changes in studentprofile please edit in Student.scss  '../StudentContainer/Component/HSGStudentGrid/Student.scss'

// const getPrettyDate = (date) => (format) => moment(date).format(format);

const StudentProfile = withRouter((props) => {
  // const { getAssessmentFilters, episode, newStudent, fetchNewFilteredList, addNewFilter } = props;
  const {
    getAssessmentFilters,
    fetchNewFilteredList,
    addNewFilter,
    newStudent,
    episode,
  } = props;
  const [selectedBillingId, setSelectedBillingId] = useState(
    Number(props.selectedBillingId) || props.currentProgram?.billing?.id,
  );
  const selectedProgram =
    props.programs?.find(
      (program) => Number(program.billing?.id) === Number(selectedBillingId),
    ) || props.currentProgram;

  const handleAssessmentYearChange = (billingId) => {
    setSelectedBillingId(Number(billingId));
  };
  const getSelectedAssessmentEventTrackId = () => {
    const latestEventTrackId = props?.studentList?.[0]?.latest_event_id;

    const savedBillingId = Number(sessionStorage.getItem("selectedBillingId"));
    const resolvedBillingId =
      savedBillingId &&
      props.programs?.some((program) => program.billing?.id === savedBillingId)
        ? savedBillingId
        : props?.currentProgram?.billing?.id;

    let eventTrackId =
      latestEventTrackId || props?.startNodeMap?.[resolvedBillingId]?.id;

    const currentBillingId = Number(props?.currentProgram?.billing?.id);
    const selectedBillingIdNumber = Number(selectedBillingId);
    const hasLocalYearSelection =
      selectedBillingId != null &&
      selectedBillingId !== "" &&
      selectedBillingIdNumber !== currentBillingId;

    if (hasLocalYearSelection) {
      eventTrackId =
        props?.startNodeMap?.[selectedBillingIdNumber]?.id || eventTrackId;
    }

    return eventTrackId;
  };
  const selectedAssessmentEventTrackId = getSelectedAssessmentEventTrackId();

  const [selectedYear, setSelectedYear] = useState("2024");
  const [student, setStudent] = useState([{}]);
  const [onReload, SetonReload] = useState(true);
  const [organizationId, setOrganizationId] = useState(props.organizationId);
  const [episodeHeader, setEpisodesHeader] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isEpisodeModalOpen, setEpisodeModalOpen] = useState(false);
  const [studentData, setStudentData] = useState([]);

  const [vaccineList, setVaccineList] = useState([]);
  const { vaccines } = props;

  const [showModal, setShowModal] = useState(false);
  const [defaultLimit, setDefaultLimit] = useState(5);
  const [defaultOffset, setDefaultOffset] = useState(0);
  const [defaultSortField, setDefaultSortField] = useState("modified_time");
  const [defaultSortBy, setDefaultSortBy] = useState("desc");
  const [defaultSearchString, setDefaultSearchString] = useState("");
  // console.log("Props.newStudent", JSON.stringify(props?.newStudent, null, 2));
  // console.log("Props.studentList", JSON.stringify(props?.studentList, null, 2));

  const [studentEpisodeHeader, setStudentEpisodeHeader] = useState({});

  // const showAddEpisodeButton = roleType === 19;
  const showAddEpisodeButton = props.roleType === 19 ? true : false;

  const [assessmentStatus, setAssessmentStatus] = useState([]);
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const [customAlertMessage, setCustomAlertMessage] = useState("");

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    const { episodeHeader, studentId, organizationId } = props;
    const newStudentEpisodeHeader = {
      inLimit: defaultLimit,
      inOffset: defaultOffset,
      inSortField: defaultSortField,
      inSortBy: defaultSortBy,
      inStudentId: studentId,
      inOrganizationId: organizationId,
      inSearchString: defaultSearchString,
    };
    setStudentEpisodeHeader(newStudentEpisodeHeader);
    //fetch infirmary episodes fror kid
    props.fetchEpisodeSearch(
      buildHeader(newStudentEpisodeHeader, episodeHeader),
    );
    //fetch details with assessmen data
    props.fetchStudentProfileSearch(
      buildHeader({
        inOrganizationId: organizationId,
        inSearchString: props.newStudent?.uuid,
      }),
    );
  }, []);

  // student list
  useEffect(() => {
    const studentId =
      props?.newStudent?.student_id || props?.newStudent?.user_id;

    if (!studentId) return;

    const eventTrackId = selectedAssessmentEventTrackId;

    if (!eventTrackId) return;

    props.fetchStudentAssessmentStatus(
      buildHeader({
        inEventTrackId: eventTrackId,
        studentId,
      }),
    );
  }, [
    selectedAssessmentEventTrackId,
    selectedBillingId,
    props?.newStudent?.student_id,
    props?.newStudent?.user_id,
    props?.currentProgram?.billing?.id,
    props?.programs,
    props?.studentList?.[0]?.latest_event_id,
  ]);

  useEffect(() => {
    // Fetch vaccinations when the modal is opened

    if (isOpen) {
      props.fetchVaccination();
      // props.setLoader()
    }
  }, [isOpen]);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const toggleEpisodeModal = (flag) => {
    setEpisodeModalOpen({
      toggleEpisodeModal: flag,
    });
    setShowModal(false);
  };
  const initializeTooltips = () => {
    const disabledButtons = document.querySelectorAll(
      ".add-episode-disabled-tooltip",
    );

    disabledButtons.forEach((element) => {
      if (!element._tippy) {
        tippy(element, {
          content: "User Not Allowed",
          placement: "top",
          arrow: true,
          delay: [100, 0],
          theme: "hsg-tooltip",
        });
      }
    });
  };
  useEffect(() => {
    initializeTooltips();

    return () => {
      document
        .querySelectorAll(".add-episode-disabled-tooltip")
        .forEach((element) => {
          if (element._tippy) {
            element._tippy.destroy();
          }
        });
    };
  }, [showAddEpisodeButton]);

  const closeEpisodeForm = async () => {
    try {
      setShowModal(true);
      await props.fetchStudentProfileSearch(
        buildHeader({
          inOrganizationId: props.organizationId,
          inSearchString: props.newStudent?.uuid,
        }),
      );
      // await props.fetchCustomStudentList(props.studentHeader);
      props.unsetLoader();
      setShowModal(false);
    } catch (error) {
      console.error("Error closing episode form:", error);

      setShowModal(false);
    }
  };

  const getIconByActivityId = (activityId) => {
    switch (activityId) {
      case 21:
        return growthnormal;
      case 22:
        return growyellow;
      case 51:
        return physicalnormal;
      case 52:
        return physicalyellow;
      case 31:
        return entnormal;
      case 32:
        return entyellow;
      case 41:
        return eyenormal;
      case 42:
        return eyeyellow;
      case 61:
        return toothnormal;
      case 62:
        return toothyellow;
      default:
        return "";
    }
  };

  const checkBackground = (activityId) => {
    if (!studentData || !studentData.results) return {};

    const activity = studentData?.results.find(
      (result) => result?.in_activity_id === activityId,
    );

    if (!activity) return {};

    return { backgroundColor: getIconByActivityId(activityId) };
  };

  const updateSelectedYear = (year) => {
    setSelectedYear(year);
  };

  const openStudentProfile = (studentId) => {
    setStudentProfileActive(!!studentId);
    setStudentId(studentId);
  };

  // const isSafari = () => {
  //     const ua = navigator.userAgent.toLowerCase();
  //     return ua.includes('safari') && !ua.includes('chrome');
  //   };

  //   const style = {
  //     marginTop: isSafari() ? '-389px' : '432px'
  //   };
  useEffect(() => {
    if (props.studentList && props.studentList.length == 1)
      //    { let student= formatStudentData(props.studentList)}
      return setStudent(formatStudentData(props.studentList));

    // return () => {

    // }
  }, [props.studentList]);

  const onreload = () => {
    window.location.reload();
  };

  const toggleModal1 = () => {
    setShowModal(!showModal);
  };
  const handleReportNavigation = (item, type, activityId) => {
    // console.log("item", JSON.stringify(item, null, 2));
    // console.log("type", JSON.stringify(type, null, 2));
    // console.log("activityId", JSON.stringify(activityId, null, 2));
    const currentAssessment = props.assessmentStatus?.find(
      (status) => status.in_activity_id === Number(activityId),
    );

    if (currentAssessment && currentAssessment.remarks) {
      try {
        const parsedRemarks = JSON.parse(currentAssessment.remarks);

        if (parsedRemarks.key === 105) {
          setShowCustomAlert(true);
          setCustomAlertMessage(parsedRemarks.value);

          setTimeout(() => {
            setShowCustomAlert(false);
            setCustomAlertMessage("");
          }, 4000);

          return;
        }
      } catch (error) {
        console.error(error);
      }
    }

    const reportConfig = REPORT_TYPES.find(
      (option) => option.label.toLowerCase() === type.toLowerCase(),
    );

    const eventTrackId = selectedAssessmentEventTrackId;

    if (reportConfig) {
      const navigationState = {
        ...item,
        eventTrackId: eventTrackId,
        activityId: reportConfig.value,
      };

      sessionStorage.setItem(
        "report_navigation_state",
        JSON.stringify(navigationState),
      );

      window.open(reportConfig.pathname, "_blank");
    } else {
      if (typeof openNewTab === "function") {
        openNewTab(item.uuid, type);
      }
    }
  };

  const RenderAssessmentBlock = ({ student, studentData }) => {
    const isAssessmentNotDone = (statusItem) => {
      if (!statusItem?.remarks) {
        return false;
      }

      try {
        const remarks =
          typeof statusItem.remarks === "string"
            ? JSON.parse(statusItem.remarks)
            : statusItem.remarks;

        return remarks?.key === 105;
      } catch (error) {
        console.error(
          "Error parsing assessment remarks:",
          statusItem.remarks,
          error,
        );

        return false;
      }
    };

    const assessments = [
      {
        id: 2,
        label: "GROWTH REPORT",
        activityId: 2,
        normalIcon: getIconByActivityId(21),
        abnormalIcon: getIconByActivityId(22),
        greyIcon: growgrey,
        route: "growth",
        bgClass: "light",
        marginTop: "-56px",
        onclick: () => handleReportNavigation(newStudent, "Growth", 2),
      },

      {
        id: 3,
        label: "PHYSICAL ASSESSMENT",
        activityId: 5,
        normalIcon: getIconByActivityId(51),
        abnormalIcon: getIconByActivityId(52),
        greyIcon: physicqlgrey,
        route: "physical",
        bgClass: "light2",
        onclick: () => handleReportNavigation(newStudent, "Physical", 5),
      },

      {
        id: 4,
        label: "EYE ASSESSMENT",
        activityId: 4,
        normalIcon: getIconByActivityId(41),
        abnormalIcon: getIconByActivityId(42),
        greyIcon: eyegrey,
        route: "eye",
        bgClass: "light3",
        onclick: () => handleReportNavigation(newStudent, "Eye", 4),
      },

      {
        id: 5,
        label: "ENT ASSESSMENT",
        activityId: 3,
        normalIcon: getIconByActivityId(31),
        abnormalIcon: getIconByActivityId(32),
        greyIcon: entgrey,
        route: "ent",
        bgClass: "light4",
        onclick: () => handleReportNavigation(newStudent, "ENT", 3),
      },

      {
        id: 6,
        label: "DENTAL ASSESSMENT",
        activityId: 6,
        normalIcon: getIconByActivityId(61),
        abnormalIcon: getIconByActivityId(62),
        greyIcon: toothgrey,
        route: "dental",
        bgClass: "light5",
        onclick: () => handleReportNavigation(newStudent, "Dental", 6),
      },
    ];

    // const isPublished =
    //   student &&
    //   student.status &&
    //   student.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED;

    // console.log("student", JSON.stringify(student, null, 2));

    if (student) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          {assessments.map((a) => {
            const statusItem = props.assessmentStatus?.find(
              (s) => s.in_activity_id === a.activityId,
            );
            // console.log(
            //   "props.assessmentStatus",
            //   JSON.stringify(props.assessmentStatus, null, 2),
            // );
            // console.log(
            //   "assessmentStatus",
            //   JSON.stringify(assessmentStatus, null, 2),
            // );
            const isNotDone =
              props.assessmentStatus?.length == 0 ||
              isAssessmentNotDone(statusItem);

            const isNormal = statusItem?.status === "Normal";

            if (isNotDone) {
              return (
                <div
                  key={a.id}
                  className={`borderRadius ${a.bgClass}`}
                  style={{
                    cursor: "not-allowed",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    padding: "0px 10px",
                    gap: 15,

                    // Grey/disabled appearance
                    opacity: 0.7,
                    backgroundColor: "#E5E5E5",

                    // Prevent clicking
                    pointerEvents: "none",
                  }}
                >
                  <img
                    className="assessmenticons"
                    src={a.greyIcon}
                    alt={a.label}
                  />

                  <span className="asment-txtnew">REPORT IS NOT AVAILABLE</span>
                </div>
              );
            }

            return (
              <div
                key={a.id}
                className={`borderRadius ${a.bgClass}`}
                style={{
                  ...checkBackground(a.id),
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "0px 10px",
                  gap: 15,
                }}
                onClick={a.onclick}
              >
                <img
                  className="assessmenticons"
                  src={isNormal ? a.normalIcon : a.abnormalIcon}
                  alt={a.label}
                />

                <span className="asment-txtnew">{a.label}</span>
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {assessments?.map((a) => {
          return (
            <div
              key={a.id}
              className={`borderRadius ${a.bgClass}`}
              style={{
                cursor: "not-allowed",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "0px 10px",
                gap: 15,

                opacity: 0.7,
                backgroundColor: "#E5E5E5",

                pointerEvents: "none",
              }}
            >
              <img className="assessmenticons" src={a.greyIcon} alt={a.label} />

              <span className="asment-txtnew">REPORT IS NOT AVAILABLE</span>
            </div>
          );
        })}
      </div>
    );
  };
  const buildHeader = (newHeader, oldHeader) =>
    Object.assign({}, oldHeader, newHeader);

  const _calculateAge = () => {
    // birthday is a date
    var ageDifMs = Date.now() - new Date(props.newStudent.dob).getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return parseInt(
      (ageDate.getUTCFullYear() - 1970 + ("." + ageDate.getMonth())) * 12,
    );
  };

  //fetching year tab from dashboard//

  useEffect(() => {
    let organization = JSON.parse(Phi.Storage.getItem("organization"));
    if (organization) {
      if (
        props.currentProgram &&
        Object.keys(props.currentProgram).length > 0
      ) {
        let startNode = props?.currentProgram?.billing
          ? props?.startNodeMap?.[props?.currentProgram?.billing?.id]
          : null;
      } else {
        props.getProgramByOrganization(organization[0]?.org_id);
      }
    }

    // if (assessmentStatus?.length == 0) {
    //   setAssessmentStatus(props.assessmentStatus);
    // }
  }, []);

  const _renderEpisodeFormBody = (props) => (
    <EpisodeForm
      initializeForm={(data) => props.initializeForm(data)}
      toggleModal={(flag) => toggleEpisodeModal(flag)}
      postEpisode={(customJson, episodeType) =>
        props.postStudentEpisodeInfo(
          props.studentList?.[0]?.student_id ||
            props.newStudent?.student_id ||
            props.newStudent?.user_id,
          customJson,
          episodeType,
        )
      }
      toggleEpisodeModal={(flag) => toggleEpisodeModal(flag)}
      onClose={() => toggleEpisodeModal(false)}
      closeEpisodeForm={closeEpisodeForm}
      metaData={props.metaData}
      age={_calculateAge()}
      clearForm={() => props.clearForm()}
    />
  );

  const _renderEpisodeFormModal = (props) => (
    <HSGPopupContainer
      show={toggleEpisodeModal}
      header={"Add Episode"}
      onClose={() => isOpen(false)}
      onSubmit={() => toggleEpisodeModal(false)}
      // onSubmit={(data) => toggleEpisodeModal(data)}
      onHide={() => toggleEpisodeModal(false)}
      body={_renderEpisodeFormBody(props)}
      closeEpisodeForm={closeEpisodeForm}
      // closeEpisodeForm = {()=>props.closeEpisodeForm}
      clearForm={props.clearForm}
    />
  );

  const getStartNode = (billingId, s_Map) => {
    for (let eachProgram in s_Map) {
      if (s_Map[eachProgram].billing_id === billingId) return eachProgram;
    }
    return false;
  };

  const handleReportTimeChange = (e) => {
    const newBillingId = parseInt(e.target.value, 10);
    const newStartNode = getStartNode(newBillingId, props.startNodeMap);
    props.changeReportInReducer(newBillingId);
    newStartNode &&
      props.fetchOverViewReport(getStartNode(newBillingId, props.startNodeMap));
  };

  //fetching year tab from dashboard end here//

  let MonthOption = [];

  // Loop to generate options
  for (let i = 0; i <= 12; i++) {
    // Pad the number with leading zeros if necessary
    let value = i < 10 ? "0" + i : i;
    MonthOption.push(
      <option key={i} value={value}>
        {value}
      </option>,
    );
  }

  let YearsOptions = [];

  // Loop to generate options for ages up to 99
  for (let i = 0; i <= 5; i++) {
    // Pad the number with leading zeros if necessary
    let value = i < 10 ? "0" + i : i;
    YearsOptions.push(
      <option key={i} value={value}>
        {value}
      </option>,
    );
  }

  const formatStudentData = (data) => {
    if (!data) {
      return [];
    } else {
      let genderMap = {
        M: "MALE",
        F: "FEMALE",
        O: "OTHER",
      };

      let newData = data.map((d) => {
        let status = d?.status;
        let studentInfo = d?.student_inf?.[0];
        let studentCustom = d?.student_inf?.[0]?.json_value;

        let episodes = d?.student_episodes?.length
          ? d.student_episodes[0]
          : null;

        let studentGrowthEpisode =
          episodes?.episode?.filter((a) => a?.type === 1) || [];
        let studentEyeEpisode =
          episodes?.episode?.filter((a) => a?.type === 2) || [];

        let lattestEventId = d?.mains?.length
          ? d?.mains[0]?.lattestEventId
          : null;
        let studentAssessmentAll = d?.mains || [];

        let studentAssessment =
          d?.mains?.filter(
            (main) => main.event_track_id == d?.latest_event_id,
          ) || [];
        let latestGrowthEpisode = studentGrowthEpisode?.length
          ? studentGrowthEpisode[0]?.episode_custom_json
          : {};
        let latestEyeEpisode = studentEyeEpisode?.length
          ? studentEyeEpisode[0]?.episode_custom_json
          : {};

        let d_object = {
          fivePerc: episodes?.five_perc,
          eightyFivePerc: episodes?.eightyfive_perc,
          idealAtFive: episodes?.ideal_at_five,
          idealAtEightyFive: episodes?.ideal_at_eighty_five,
          trueBMI: episodes?.true_bmi,
          studentId: d.student_id,
          uuid: studentInfo?.uuid,
          section: studentInfo?.section,
          class: studentInfo?.class,
          firstName: studentInfo?.name,
          dob: studentInfo?.dob,
          gender: genderMap[studentInfo?.gender],
          admissionNumber: studentInfo?.admission_number,
          phoneNumber: studentInfo?.user_phone_number,
          email: studentInfo?.user_email,
          custom: studentCustom,
          foodAllergies: studentCustom?.foodAllergies,
          medicineAllergies: studentCustom?.medicineAllergies,
          bloodGroup: studentCustom?.bloodGroup,
          parentName: studentCustom?.parent_name,
          authenticationCode: studentCustom?.authentication_code,
          lattestEventId: lattestEventId,
          growthEpisodes: studentGrowthEpisode,
          eyeEpisodes: studentEyeEpisode,
          studentAssessment: studentAssessment,
          studentAssessmentAll: studentAssessmentAll,
          latestBMI: episodes?.new_bmi
            ? episodes.new_bmi.toUpperCase() + ` (${episodes.new_bmi_val})`
            : null,
          latestHeight: latestGrowthEpisode?.med_height,
          latestWeight: latestGrowthEpisode?.med_weight,
          latestPulse: latestGrowthEpisode?.med_heart_rate,
          latestBPSYS: latestGrowthEpisode?.med_bp_sys,
          latestBPDIA: latestGrowthEpisode?.med_bp_dia,
          latestLeftEye: latestEyeEpisode?.leftEye,
          latestRightEye: latestEyeEpisode?.rightEye,
          status: status,
        };

        return d_object;
      });

      return newData;
    }
  };

  const checkAilmentKeyExists = (studentAssessment, keysToFind) => {
    // Check if studentAssessment is defined and not empty
    if (
      studentAssessment &&
      studentAssessment.metric &&
      studentAssessment.metric.ailment
    ) {
      // Iterate over the ailment array in the metric object
      for (let ailment of studentAssessment.metric.ailment) {
        // Check if the ailment key matches any of the keysToFind
        if (keysToFind.includes(ailment.key)) {
          return "Yes";
        }
      }
    }
    return "N.A";
  };

  useEffect(() => {
    if (!setEpisodeModalOpen) {
      props.closeStudentProfile();
    }
  }, [setEpisodeModalOpen, props]);

  const checkEyeLabel = (studentAssessment, keyToFind) => {
    // Check if studentAssessment is defined and not empty
    if (
      studentAssessment &&
      studentAssessment.metric &&
      studentAssessment.metric.ailment
    ) {
      // Iterate over the ailment array in the metric object
      for (let ailment of studentAssessment.metric.ailment) {
        // Check if the ailment key matches the keyToFind
        if (ailment.key === keyToFind) {
          return "Yes";
        }
      }
    }
    return "N.A";
  };
  function getRandomLightColor() {
    const letters = "ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 6)]; // Only light colors
    }
    return color;
  }

  const isReportAvailable =
    (props.newStudent &&
      props.newStudent.status &&
      props.newStudent.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED) ||
    (props?.studentList?.[0]?.student_id &&
      props?.studentList?.[0]?.latest_event_id) ||
    props?.studentList?.[0]?.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED;

  function isDarkColor(color) {
    // Convert hex color to RGB
    color = color?.substring(1); // Remove #
    const rgb = parseInt(color, 16);
    const r = (rgb >> 16) & 0xff; // Extract red
    const g = (rgb >> 8) & 0xff; // Extract green
    const b = (rgb >> 0) & 0xff; // Extract blue

    // Calculate luminance
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // Check if color is dark
    return luminance < 128;
  }

  function getInitials(name) {
    const nameArray = name?.split(" "); // Using optional chaining here
    let firstName, lastName;

    if (nameArray?.length === 1) {
      firstName = nameArray[0]?.charAt(0)?.toUpperCase() || "";
      lastName = ""; // No last name available
    } else {
      firstName = nameArray?.[0]?.charAt(0)?.toUpperCase() || ""; // Using optional chaining here
      lastName =
        nameArray?.[nameArray.length - 1]?.charAt(0)?.toUpperCase() || ""; // Using optional chaining here
    }

    return firstName + lastName;
  }

  const fullName = props.newStudent?.name || props.newStudent?.studentname;

  const initials = getInitials(fullName);

  const openNewTab = (hsgId, type) =>
    window.open(
      `/report/student/${
        props.startNodeMap[props.currentProgram.billing.id].id
      }/${type}/${hsgId}`,
      "_blank",
    );

  function groupEpisodesByDate(episodes) {
    const groupedEpisodes = {};
    episodes.forEach((episode) => {
      const date = new Date(
        episode.episode_custom_json.med_created,
      ).toLocaleDateString();
      if (!groupedEpisodes[date]) {
        groupedEpisodes[date] = [];
      }
      groupedEpisodes[date].push(episode.episode_custom_json);
    });
    return groupedEpisodes;
  }

  const extractSixBySix = (label) => {
    // Split the label by space
    const parts = label.split(" ");
    // Extract the last part which contains "6/6"
    return parts[parts.length - 1];
  };

  const downloadStudentReport = (studentId) => {
    props.setLoader();

    let startNode = props.startNodeMap[props.currentProgram.billing.id];
    props.getStudentReport("health_card", {
      startNodeId: startNode.id,
      studentId,
      type: "pdf",
    });
  };

  const responseData = props.vaccines?.data;

  const renderRows = () => {
    const responseData = props.vaccines.data; // Assuming props.vaccines.data is the array of objects received from the API
    const rows = []; // Array to store the rows

    for (let i = 0; i < responseData.length; i++) {
      const item = responseData[i];
      let name = item.name;
      let id = item.id;
      const customJson = JSON.parse(item.custom_json); // Parse custom_json string into an array of objects

      // If custom_json contains doses, create additional rows for each dose
      if (customJson.length > 0) {
        for (let j = 0; j < customJson.length; j++) {
          const dose = customJson[j];
          let doseRow = {
            name,
            id,
            catchUpPeriod: dose.catchUpPeriod,
            ageRecommended: dose.ageRecommended,
          };
          rows.push(doseRow); // Add the dose row to the rows array
        }
      } else {
        rows.push({ name, id }); // If no doses present, use the main row
      }
    }
  };

  const weightChange =
    student[0].trueBMI > student[0].eightyFivePerc
      ? student[0].idealAtEightyFive > 0
        ? student[0].idealAtEightyFive
        : -student[0].idealAtEightyFive
      : student[0].idealAtFive > 0
        ? student[0].idealAtFive
        : -student[0].idealAtFive;

  return (
    <RootLayout props={props}>
      <div
        style={{
          display: "flex",
          padding: "1em 2em",
          flexDirection: "column",
          flex: 1,
          gap: "1.5rem",
        }}
      >
        <BackButton />
        <div
          className="borderRadius"
          style={{ flex: 1, backgroundColor: "white", paddingBottom: "2rem" }}
        >
          <StudentCard
            props={props}
            YearsOptions={YearsOptions}
            checkAilmentKeyExists={checkAilmentKeyExists}
            MonthOption={MonthOption}
            initials={initials}
            weightChange={weightChange}
            extractSixBySix={extractSixBySix}
            getRandomLightColor={getRandomLightColor}
            isOpen={isOpen}
            modalRef={modalRef}
            student={student}
            toggleModal={toggleModal}
            vac={vac}
            downloadStudentReport={downloadStudentReport}
            isReportAvailable={isReportAvailable}
          />
        </div>

        <div
          style={{
            flex: 1,

            display: "flex",
            flexDirection: "row",
            gap: "3rem",
          }}
        >
          <div
            style={{
              flex: 0.5,
              flexDirection: "column",
            }}
          >
            <div>
              <RenderYearTab
                program={selectedProgram}
                history={props.programHistory}
                changeTab={handleAssessmentYearChange}
              />
            </div>
            <RenderAssessmentBlock student={newStudent} studentData={episode} />
          </div>
          <div
            className="borderRadius"
            style={{ backgroundColor: "white", padding: "2rem", flex: 1 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",

                paddingBottom: "2rem",
              }}
            >
              <div className="INFIRMARY-TIMELINE  ">INFIRMARY TIMELINE</div>

              <div>
                {showAddEpisodeButton ? (
                  <button
                    style={{
                      display: "inline-flex",
                      marginLeft: "2rem",
                      width: "auto",
                      alignItems: "center",

                      fontSize: "1.2rem",
                      borderRadius: ".5rem",
                      cursor: "pointer",
                      marginTop: 0,
                      height: "30px",
                      padding: "0 30px",
                      fontWeight: "400",
                    }}
                    className="list_btn"
                    onClick={() => toggleModal1()}
                  >
                    Add Episode
                  </button>
                ) : (
                  <div
                    className="add-episode-disabled-tooltip"
                    style={{
                      display: "inline-flex",
                      cursor: "not-allowed",
                    }}
                  >
                    <button
                      disabled
                      style={{
                        display: "inline-flex",
                        marginLeft: "2rem",
                        width: "auto",
                        alignItems: "center",
                        height: "30px",
                        fontSize: "1.2rem",
                        borderRadius: ".5rem",
                        marginTop: 0,
                        fontWeight: "400",
                        padding: "0 30px",
                        cursor: "not-allowed",

                        backgroundColor: PALLETTE.chip,
                        borderColor: PALLETTE.gray,
                        color: PALLETTE.gray,
                      }}
                      className="  list_btn "
                      onClick={() => undefined}
                    >
                      Add Episode
                    </button>
                  </div>
                )}
              </div>
            </div>

            {showModal && (
              <HSGCard
                headingLeft={newStudent?.name}
                headingRight={
                  <div>
                    {setEpisodeModalOpen && _renderEpisodeFormModal(props)}
                  </div>
                }
              ></HSGCard>
            )}

            <div
              style={{
                overflowY: "scroll",
                height: "350px",
                overflowX: "hidden",
              }}
            >
              {student?.map((studentData, sIndex) => (
                <React.Fragment key={sIndex}>
                  {studentData?.growthEpisodes &&
                  studentData?.growthEpisodes[0]?.episode_custom_json ? (
                    studentData?.growthEpisodes?.map((episode, eIndex) => (
                      <div
                        key={eIndex}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flex: 1,
                          gap: 25,
                          padding: "0px 15px",
                        }}
                      >
                        {/* col 1 */}
                        <div
                          className="timeline-col"
                          style={{ height: "auto" }}
                        >
                          <img
                            className="studentprofileimg "
                            src={studentprofile}
                            alt="Student Profile"
                          />
                          <div className="vl-profile" />
                        </div>

                        <div style={{ padding: "5px 0px" }}>
                          {(sIndex !== student.length - 0 ||
                            eIndex !==
                              studentData.growthEpisodes.length - 1) && (
                            <p className="timeline-txtv2">
                              {props.newStudent?.studentname}{" "}
                              {props.newStudent.name}
                            </p>
                          )}
                          <div className="timeline-datev2">
                            {(() => {
                              const rawDate =
                                episode.episode_custom_json.med_created;
                              const date = new Date(rawDate);

                              const months = [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec",
                              ];

                              const day = date.getDate();
                              const month = months[date.getMonth()];
                              const year = date.getFullYear();
                              let hours = date.getHours();
                              let minutes = date.getMinutes();

                              hours = (hours < 10 ? "0" : "") + hours;
                              minutes = (minutes < 10 ? "0" : "") + minutes;

                              return `${day} ${month} ${year}, ${hours}:${minutes}`;
                            })()}
                          </div>

                          <div
                            style={{
                              width: "100%", // Changed from fixed 400px to allow wrapping
                              marginTop: "1em",
                            }}
                          >
                            <div
                              style={{
                                paddingBottom: "1.5rem",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "15px",
                              }}
                            >
                              {Object.entries(keyMappings)?.map(
                                ([key, label]) => {
                                  const rawValue =
                                    episode.episode_custom_json[key];

                                  if (
                                    rawValue === null ||
                                    rawValue === undefined ||
                                    rawValue === ""
                                  ) {
                                    return null;
                                  }

                                  let displayValue = rawValue;

                                  if (typeof rawValue === "boolean") {
                                    displayValue = rawValue ? "Yes" : "No";
                                  } else if (
                                    typeof rawValue === "object" &&
                                    rawValue !== null
                                  ) {
                                    displayValue =
                                      rawValue.label || rawValue.value || "N.A";
                                  }
                                  return (
                                    <div
                                      key={key}
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "flex-start",

                                        minWidth: "20%",
                                      }}
                                    >
                                      <p className="complaint-txt">{label}:</p>
                                      <p className="complaint-aftertxt">
                                        {displayValue || "N.A"}
                                      </p>
                                    </div>
                                  );
                                },
                              )}
                            </div>

                            {eIndex ===
                              studentData.growthEpisodes.length - 1 && (
                              <div className=""></div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <React.Fragment>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="col-md-6 " style={{ width: "170%" }}>
                            <div className="my-5 "> No Data Uploaded Yet!.</div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </RootLayout>
  );
});

export default withRouter(StudentProfile);
